import { defineAbility, createAliasResolver } from '@casl/ability'

// add custom alias as 'crud' alias was removed from the library
const aliases = createAliasResolver({
  crud: ['create', 'read', 'update', 'delete'],
})

const defAbility = (resolver) => {
  return defineAbility(resolver, { resolveAction: aliases })
}

const buildAdminAbility = defAbility((can, cannot) => {
  can('crud', 'all')
  can('switch', 'Impersonation')
  can('reload', 'Tickets')
})

const adminImpersonatedAbility = defAbility((can, cannot) => {
  can('switch', 'Impersonation')
})

const adminReadOnly = defAbility((can, cannot) => {
  can('switch', 'Impersonation')
  can('read', 'AdminPages')
  can('reload', 'Tickets')
})

const adminReadOnlyImpersonated = defAbility((can, cannot) => {
  can('switch', 'Impersonation')
})

const buildPowerUserAbility = defAbility((can, cannot) => {
  can('switch', 'Impersonation')
  can('read', 'PowerUserPages')
})

const buildPowerUserImpersonatedAbility = defAbility((can, cannot) => {
  can('switch', 'Impersonation')
})

const partner = defAbility((can, cannot) => {
})

function buildAbilityFor (userRole) {
  switch (userRole) {
    case 'admin':
      return buildAdminAbility
    case 'admin_read_only':
      return adminReadOnly
    case 'admin_read_only_impersonated':
      return adminReadOnlyImpersonated
    case 'admin_impersonated':
      return adminImpersonatedAbility
    case 'power_user':
      return buildPowerUserAbility
    case 'power_user_impersonated':
      return buildPowerUserImpersonatedAbility
    default:
      return partner
  }
}

export default buildAbilityFor
